import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'external-url',
		path: '/redirect',
		component: loadable(async () => import(/* webpackChunkName: "pages/externalUrl" */ './index'), {
			exportName: 'ExternalUrl',
			fallback: Loading,
		}),
		frame: {
			header: true,
			footer: false,
		},
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
